import React, { useState } from "react";
import { Icon, Dropdown, Menu, Spin } from "antd";

export const ChatInviteAccept = ({
  handleAcceptInvite,
  handleDeclineInvite,
  handleCancelInvite,
  handleDeleteInvite,
  users,
  currentUser,
  loading,
}) => {
  const [activeTab, setActiveTab] = useState("received");
  
  const sentInvites = users.filter((invite) => invite.senderId === currentUser.id && invite.invitationStatus === "PENDING");
  const receivedInvites = users.filter((invite) => invite.senderId !== currentUser.id && invite.invitationStatus === "PENDING");

  const InviteItem = ({ invite, isSent }) => {
    const isSender = invite.senderId === currentUser.id;
    const displayUser = isSender ? invite.ReceiverUser : invite.SenderUser;
    const name = (displayUser && displayUser.name) || (invite && invite.name) || "Unknown User";
    const image = (displayUser && displayUser.image) || invite.image;

    const menu = (
      <Menu onClick={({ key }) => {
        if (key === "delete") handleDeleteInvite(invite);
        if (key === "cancel") handleCancelInvite(invite);
      }}>
        <Menu.Item key="delete" style={{ color: "#ff4d4f" }}>
          <Icon type="delete" /> Delete Invitation
        </Menu.Item>
        <Menu.Item key="cancel">
          <Icon type="close-circle" /> Cancel Invitation
        </Menu.Item>
      </Menu>
    );

    return (
      <div className="user-item-invite modern-invite-item" style={{ flexDirection: 'column', alignItems: 'stretch', gap: '4px' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', width: '100%' }}>
          {image ? (
            <div className="invite-avatar-wrapper">
              <img src={image} height="44" width="44" alt="avatar" className="invite-avatar" />
            </div>
          ) : (
            <div className="contact-chat-logo invite-logo-placeholder" style={{ flexShrink: 0, width: '44px', height: '44px' }}>
              {name.split(" ").map((part) => part[0]).join("")}
            </div>
          )}
          
          <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: '2px', alignSelf: 'center' }}>
             <span className="contact-chat-name" title={name} style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
               {name}
             </span>
             <span className="invite-status-tag" style={{ margin: 0 }}>
               {isSent ? "SENT INVITATION" : "RECEIVED INVITATION"}
             </span>
          </div>

          <div className="invite-actions" style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: '8px', alignSelf: 'center' }}>
            {isSent && (
              <>
                <span className="pending-badge">Pending</span>
                <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
                  <button className="chat-menu-button">
                    <Icon type="ellipsis" />
                  </button>
                </Dropdown>
              </>
            )}
          </div>
        </div>

        {!isSent && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginTop: '6px' }}>
            <div className="received-actions" style={{ display: 'flex', gap: '8px' }}>
              <button
                className="chat-accept-invite-button"
                onClick={() => handleAcceptInvite(invite)}
                style={{ fontSize: '12px', padding: '4px 12px' }}
              >
                Accept
              </button>
              <button
                className="chat-decline-invite-button"
                onClick={() => handleDeclineInvite(invite)}
                style={{ fontSize: '12px', padding: '4px 12px' }}
              >
                Decline
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="user-chat-list invite-manager-container">
      <div className="invite-secondary-tabs">
        <button 
          className={`invite-sub-tab ${activeTab === 'received' ? 'active' : ''}`}
          onClick={() => setActiveTab('received')}
        >
          Received
          {receivedInvites.length > 0 && <span className="invite-count-badge small-badge">{receivedInvites.length}</span>}
        </button>
        <button 
          className={`invite-sub-tab ${activeTab === 'sent' ? 'active' : ''}`}
          onClick={() => setActiveTab('sent')}
        >
          Sent
          {sentInvites.length > 0 && <span className="invite-count-badge small-badge">{sentInvites.length}</span>}
        </button>
      </div>

      <div className="invite-tab-content" style={{ marginTop: '16px' }}>
        {loading ? (
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            <Spin indicator={<Icon type="loading" style={{ fontSize: 24, fill: '#2a3da3' }} spin />} />
          </div>
        ) : activeTab === 'received' ? (
          receivedInvites.length > 0 ? (
            <div className="invite-section-list">
              {receivedInvites.map((invite) => (
                <InviteItem key={invite.id} invite={invite} isSent={false} />
              ))}
            </div>
          ) : (
            <div className="no-invites-placeholder">
              <Icon type="inbox" style={{ fontSize: '48px', color: '#cbd5e0', marginBottom: '16px' }} />
              <p>No received invitations at the moment.</p>
            </div>
          )
        ) : (
          sentInvites.length > 0 ? (
            <div className="invite-section-list">
              {sentInvites.map((invite) => (
                <InviteItem key={invite.id} invite={invite} isSent={true} />
              ))}
            </div>
          ) : (
            <div className="no-invites-placeholder">
              <Icon type="send" style={{ fontSize: '48px', color: '#cbd5e0', marginBottom: '16px' }} />
              <p>No sent invitations at the moment.</p>
            </div>
          )
        )}
      </div>
    </div>
  );
};
